import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { OrdersComponent } from '../../pages/orders/orders.component';
import { SqlWizardComponent } from '../../pages/orders/sql-wizard/sql-wizard.component';
import { RoleAccountGuard } from '../../guards/role-account.guard';

export const ordersRoutes: Routes = [
  {
    path: '',
    redirectTo: 'orders',
    pathMatch: 'full',
  },
  {
    path: 'orders/all',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.all', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/all/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.all', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/all-contracts',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.contracts', role: ['Admin', 'Supervisor','Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/all-contracts/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.contracts', role: ['Admin', 'Supervisor','Agent', 'Sales','Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/sql/new',
    component: SqlWizardComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.sqls', role: ['Admin', 'Supervisor', 'Sales', 'Agent'], account_type: ['broker'] },
  },
  {
    path: 'orders/sqls',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.sqls', role: ['Admin', 'Supervisor', 'Sales', 'Agent'], account_type: ['broker'] },
  },
  {
    path: 'orders/sqls/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.sqls', role: ['Admin', 'Supervisor', 'Sales', 'Agent'], account_type: ['broker'] },
  },

  {
    path: 'orders/sql-drafts',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.sql_draft', role: ['Admin', 'Supervisor', 'Sales', 'Agent'], account_type: ['broker'] },
  },
  {
    path: 'orders/sql-drafts/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.sql_draft', role: ['Admin', 'Supervisor', 'Sales', 'Agent'], account_type: ['broker'] },
  },
  {
    path: 'orders/drafts',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.delivered', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker'] },
  },
  {
    path: 'orders/drafts/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.delivered', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker'] },
  },
  {
    path: 'orders/offers',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.offers', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/offers/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.offers', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/rejected',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.rejected', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/rejected/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.rejected', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/authorized',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.authorized', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/authorized/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.authorized', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/denied',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.denied', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/denied/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.denied', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/contracts',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.contracts', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },

  {
    path: 'orders/contracts/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/contracts/:reference/:tab',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/contracts/add',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/signed-contracts',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.signed-contracts', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/signed-contracts/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.signed-contracts', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/cancellation-requested',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.cancellation_requested', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/cancellation-requested/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.cancellation_requested', role: ['Admin', 'Supervisor', 'Agent', 'Sales', 'Pre-sales'], account_type: ['broker', 'supplier'] },
  },


  {
    path: 'orders/digital',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.digital', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'], broker_accounts: ['idoneo.com'] },
  },
  {
    path: 'orders/digital/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.digital', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'], broker_accounts: ['idoneo.com'] },
  },
  {
    path: 'orders/cancelled',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.cancelled', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/cancelled/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.cancelled', role: ['Admin', 'Supervisor', 'Agent'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/pre-frozen',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.pre-frozen', role: ['Admin', 'Supervisor','Agent'], account_type: ['broker', 'supplier'] },
  },


  /*
    {
      path: 'orders/transport',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.transport', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/transport/:reference',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.transport', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/dealership',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.dealership', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/dealership/:reference',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.dealership', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/vehicle_delivered',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.vehicle_delivered', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/vehicle_delivered/:reference',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.vehicle_delivered', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/supplier_rejected',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.supplier_rejected', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/supplier_rejected/:reference',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.supplier_rejected', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/ownership',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.ownership', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },
    {
      path: 'orders/ownership/:reference',
      component: OrdersComponent,  canActivate: [RoleAccountGuard],
      resolve: { title: TitleResolver },
      data: { title: 'titles-menu-pages.ownership', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
    },

  {
    path: 'orders/new_vehicle_billing',
    component: OrdersComponent,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.new_vehicle_billing', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/new_vehicle_billing/:reference',
    component: OrdersComponent,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.new_vehicle_billing', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/new_vehicle_registered',
    component: OrdersComponent,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.new_vehicle_registered', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/new_vehicle_registered/:reference',
    component: OrdersComponent,  canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.new_vehicle_registered', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },


   */






  {
    path: 'orders/frozen',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.frozen', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/frozen/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.frozen', role: ['Admin', 'Supervisor'], account_type: ['broker', 'supplier'] },
  },


  //---------------------
  //---------------------
  //WORKSHOP ROUTES
  //---------------------
  //---------------------


  {
    path: 'orders/registering',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.registering', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/registering/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.registering', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/pre-delivery',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.pre-delivery', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/pre-delivery/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.pre-delivery', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/plates',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.plates', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/plates/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.plates', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/documentation',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.documentation', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/documentation/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.documentation', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },

  {
    path: 'orders/washing',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.washing', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/washing/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.washing', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
   {
    path: 'orders/logistics',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.logistics', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/logistics/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.logistics', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
   {
    path: 'orders/dealership-accessories',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.dealership-accessories', role: ['Admin', 'Supervisor', 'Workshop','Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/dealership-accessories/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.dealership-accessories', role: ['Admin', 'Supervisor', 'Workshop'], account_type: ['broker', 'supplier'] },
  },

  //---------------------
  //---------------------
  //AFTER SALES ROUTES
  //---------------------
  //---------------------
  {
    path: 'orders/after-sales',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
    {
    path: 'orders/after-sales-factory',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-factory/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-factory', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-without-requirement',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-without-requirement/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-without-requirement', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-dealership',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-dealership/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-dealership', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-billing',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-billing', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-billing/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-billing', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-registering',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-registering', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-registering/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-registering', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-prepared',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-prepared', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-prepared/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-prepared', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-logistics',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-logistics', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-logistics/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-logistics', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-rejected',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-rejected', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-rejected/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-rejected', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-delivered',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-delivered', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/after-sales-delivered/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.after-sales-delivered', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/not-delivered',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.not-delivered', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/not-delivered/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.not-delivered', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/all-after-sales',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.all-after-sales', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/all-after-sales/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.all-after-sales', role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], account_type: ['broker', 'supplier'] },
  },

////////////
  {
    path: 'orders/telemarketing-pending',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.telemarketing-pending', role: ['Admin', 'Supervisor','Telemarketing'], account_type: [ 'supplier'] },
  },
    {
    path: 'orders/telemarketing-pending/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.telemarketing-pending', role: ['Admin', 'Supervisor','Telemarketing'], account_type: [ 'supplier'] },
  },
////////////
  {
    path: 'orders/telemarketing-done',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.telemarketing-done', role: ['Admin', 'Supervisor','Telemarketing'], account_type: [ 'supplier'] },
  },
    {
    path: 'orders/telemarketing-done/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.telemarketing-done', role: ['Admin', 'Supervisor','Telemarketing'], account_type: [ 'supplier'] },
  },
  //ULTIMO

  {
    path: 'orders',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales'/* , 'Telemarketing' */], account_type: ['broker', 'supplier'] },
  },
  {
    path: 'orders/:reference',
    component: OrdersComponent, canActivate: [RoleAccountGuard],
    resolve: { title: TitleResolver },
    data: { title: 'titles-menu-pages.orders', role: ['Admin', 'Supervisor', 'Agent', 'Pre-sales', 'Sales'/* , 'Telemarketing' */], account_type: ['broker', 'supplier'] },
  },

];


export function getFilteredOrdersRoutes(accountType: string, role: string): Routes {
  return ordersRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}
